<template>
    <div>
        <Breadcrumb section-name="Income" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <form @submit.prevent="manage">
                        <div class="fixed-card-height">
                            <div class="card border-top border-0 border-4 border-primary">
                                <div class="card-body p-4">
                                    <div class="card-title d-flex align-items-center">
                                        <h5 class="mb-0 text-primary">Bank Withdraw</h5>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="row mb-3 form-group">
                                            <label class="form-label col-md-3 text-end">Date<span class="text-danger">*</span></label>
                                            <div class="col-md-6">
                                                <flat-pickr class="form-control" v-model="addEditParam.date" name="date"
                                                            :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                                <small class="invalid-feedback text-danger"></small>
                                            </div>
                                        </div>
                                        <div class="row mb-3 form-group">
                                            <label class="form-label col-md-3 text-end">Project<span class="text-danger">*</span></label>
                                            <div class="col-md-6">
                                                <select class="form-select" v-model="addEditParam.project_id" name="project_id">
                                                    <option v-for="c in projects" :value="c.id">{{ c.name }}</option>
                                                </select>
                                                <small class="invalid-feedback text-danger"></small>
                                            </div>
                                        </div>
                                        <div class="row mb-3 form-group">
                                            <label class="form-label col-md-3 text-end">Bank Name<span class="text-danger">*</span></label>
                                            <div class="col-md-6">
                                                <select class="form-select" v-model="addEditParam.bank_id" name="bank_id">
                                                    <option v-for="c in banks" :value="c.id">{{ c.name }}</option>
                                                </select>
                                                <small class="invalid-feedback text-danger"></small>
                                            </div>
                                        </div>
                                        <div class="row mb-3 form-group">
                                            <label class="form-label col-md-3 text-end">Check Number</label>
                                            <div class="col-md-6">
                                                <input type="text" class="form-control" name="check_number" v-model="addEditParam.check_number">
                                                <small class="invalid-feedback text-danger"></small>
                                            </div>
                                        </div>
                                        <div class="row mb-3 form-group">
                                            <label class="form-label col-md-3 text-end">Branch Name</label>
                                            <div class="col-md-6">
                                                <input type="text" class="form-control" name="branch_name" v-model="addEditParam.branch_name">
                                                <small class="invalid-feedback text-danger"></small>
                                            </div>
                                        </div>
                                        <div class="row mb-3 form-group">
                                            <label class="form-label col-md-3 text-end">Amount<span class="text-danger">*</span></label>
                                            <div class="col-md-6">
                                                <input type="text" class="form-control" name="amount" v-model="addEditParam.amount">
                                                <small class="invalid-feedback text-danger"></small>
                                            </div>
                                        </div>
                                        <div class="row form-group mb-3">
                                            <label class="form-label col-md-3 text-end">Withdraw By<span class="text-danger">*</span></label>
                                            <div class="col-md-6">
                                                <div class="autocomplete-input">
                                                    <input type="text" placeholder="Search by Name or ID" name="withdraw_by" class="form-control" v-model="searchParam.keyword" autocomplete="new-phone" @input="searchShareholder">
                                                    <span v-if="searchLoading" class="input-loader spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <i v-if="addEditParam.deposit_by" class="input-loader cursor-pointer bx bx-x fs-4" style="top: 0.1rem" @click="removeMember"></i>
                                                    <div class="input-result" v-if="members.length > 0">
                                                        <div class="each-box" v-for="member in members" @click="selectMember(member)">
                                                            <div class="d-flex align-items-center">
                                                                <img class="me-2" style="border-radius: 50%; height: 25px; width: 25px" :src="member.image_path" alt="">
                                                                {{ member.name }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <small class="invalid-feedback text-danger"></small>
                                            </div>
                                        </div>
                                        <div class="row mb-3 form-group">
                                            <label class="form-label col-md-3 text-end">Requisition For</label>
                                            <div class="col-md-6">
                                                <input type="text" class="form-control" name="requisition_for" v-model="addEditParam.requisition_for">
                                                <small class="invalid-feedback text-danger"></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-end">
                            <router-link :to="{name: 'bankWithdrawList'}" type="button" class="btn btn-secondary me-2 btn-width" >Close</router-link>
                            <button type="submit" class="btn btn-primary btn-width" v-if="!loading">
                                Save
                            </button>
                            <button type="button" class="btn btn-primary btn-width" v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";
import Table from "../Common/Table.vue";
export default {
    components: {Table, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Add'],
            loading: false,
            dataLoading: false,
            addEditParam: {
                project_id: '',
                date: '',
                bank_id: '',
                check_number: '',
                branch_name: '',
                amount: '',
                withdraw_by: '',
                requisition_for: ''
            },
            searchParam: {
                keyword: ''
            },
            banks: [],
            projects: [],
            searchLoading: false,
            members: []
        }
    },
    watch: {

    },
    methods: {
        searchShareholder: function () {
            this.searchLoading = true
            ApiService.POST(ApiRoutes.ShareHolder + '/search', this.searchParam, (res) => {
                this.searchLoading = false;
                if (parseInt(res.status) === 200) {
                    this.members = res.data;
                }
            });
        },
        removeMember: function () {
            this.members = []
            this.searchParam.keyword = ''
            this.addEditParam.purchase_by = ''
        },
        selectMember: function (member) {
            this.searchParam.keyword = member.name
            this.members = []
            this.addEditParam.withdraw_by = member.id
        },
        fetchBank: function() {
            ApiService.POST(ApiRoutes.Bank + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.banks = res.data.data;
                }
            });
        },
        fetchProject: function() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        manage: function () {
            ApiService.ClearErrorHandler();
            this.loading = true;
            ApiService.POST(ApiRoutes.BankWithdraw, this.addEditParam, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message);
                    this.addEditParam = {
                        project_id: '',
                        date: '',
                        bank_id: '',
                        check_number: '',
                        branch_name: '',
                        amount: '',
                        withdraw_by: '',
                        requisition_for: ''
                    };
                    this.searchParam.keyword = '';
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
    },
    mounted () {
    },
    created() {
        this.fetchProject();
        this.fetchBank();
    }
}
</script>

<style scoped>

</style>
